import { Link } from 'react-router-dom';

export default function SEOHead() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩国漫画网',
    url: 'http://dakunkj.cn/',
    description: '在韩国漫画网阅读韩漫免费漫画，在线阅读韩漫大全中的好看韩国漫画，下拉式模式让您的浏览体验更加轻松愉悦。',
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'http://dakunkj.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩国漫画网',
    url: 'http://dakunkj.cn/',
    description: '国内领先的韩漫免费在线阅读平台，提供丰富的韩国漫画资源。',
    sameAs: ['http://dakunkj.cn/'],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
    </>
  );
}